
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CREATE_CLIP_REQUEST_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientMutation } from 'Core/data/GraphQLApi';
import { createClipRequestResult } from 'Redux/actions';


function* createClipRequest({ payload }) {
    try {
        const QUERY = `
            mutation createClipRequest ($unitId: Int!, $dateRange: AWSDateTimeRange!) {
                result: createClipRequest (unitId: $unitId, dateRange: $dateRange){
                    id
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(createClipRequestResult(data?.result))
        else yield put(createClipRequestResult({ error: 'error-clip' }))

    } catch (exc) {
        yield put(createClipRequestResult({ error: exc?.error || 'error-clip' }))
        ExceptionManager(exc, "Modules/devices/.components/createClipRequest/redux/saga", "createClipRequest")
    }
}

function* watchMethods() {
    yield takeEvery(CREATE_CLIP_REQUEST_REQUEST, createClipRequest);
}
export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}